<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent" class="h-100"></app-loading-state>
<ng-template #loadedContent>
	<div class="signature-body">
		<h5>Customer Signature</h5>
		<button
			class="btn btn-sm btn-primary mb-2"
			type="button"
			data-bs-toggle="collapse"
			data-bs-target="#signature"
			aria-expanded="false"
			aria-controls="signature"
		>
			Toggle Signature Pad
		</button>
		<div class="collapse" id="signature" (show.bs.collapse)="initSignaturePad()">
			<ng-container *ngIf="customerSignatureUrl; else mustSign">
				<img
					*ngIf="!isImgLoaded"
					height="200"
					class="img-fluid placeholder-img"
					src="assets/placeholders/placeholder-animated.gif"
				/>
				<img [hidden]="!isImgLoaded" height="200" class="img-fluid" [src]="customerSignatureUrl" (load)="isImgLoaded = true" />
			</ng-container>
			<ng-template #mustSign>
				<div class="signature-container">
					<canvas #signatureCanvas></canvas>
				</div>
				<div class="button-container mt-2">
					<ng-container *ngIf="!customerSignatureUrl && !isLoading">
						<button type="button" class="btn btn-sm btn-outline-secondary w-100" (click)="clearSignature()">Clear</button>
						<button
							type="button"
							class="btn btn-sm btn-primary w-100"
							[disabled]="signaturePad && signaturePad.isEmpty()"
							(click)="saveSignature()"
						>
							Save
						</button>
					</ng-container>
				</div>
			</ng-template>
		</div>
	</div>
</ng-template>
